import { useState } from "react";
import { IoMdClose } from "react-icons/io";
import classes from "./DownloadOverlay.module.css";
import { AiFillWindows, AiFillApple } from "react-icons/ai"; // Import icons

const DownloadOverlay = ({ showOverlay, setShowOverlay }) => {
  const handleWindowsDownload = () => {
    window.location.href =
      "https://prop-trading-fun.s3.us-west-1.amazonaws.com/tcbridge5setup.exe";
  };

  // Function to handle Mac download
  const handleMacDownload = () => {
    window.location.href =
      "https://prop-trading-fun.s3.us-west-1.amazonaws.com/MetaTrader5.pkg";
  };
  return (
    <>
      {/* Overlay */}
      {showOverlay && (
        <div className={classes.overlay}>
          <div className={classes.downloadCard}>
            <IoMdClose
              className={classes.closeIcon}
              onClick={() => setShowOverlay(false)}
            />
            <h3 className="my-3">PropTrading.Fun MT5 Download</h3>
            <div className="d-flex justify-content-center gap-2">
              <button
                className="d-flex  justify-content-center align-items-center  gap-2"
                onClick={handleWindowsDownload}
              >
                <AiFillWindows size={20} /> Windows
              </button>
              <button
                className="d-flex  justify-content-center align-items-center  gap-2"
                onClick={handleMacDownload}
              >
                <AiFillApple size={20} /> Mac
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DownloadOverlay;
